import { safe } from '../../documentos/commercialExcelUtils';

/** Contenedores distintos listados en tabla (sin vacíos). */
export function pkDeclaContainerList(containers) {
  return (containers || []).map((c) => safe(c).trim()).filter(Boolean);
}

export const PK_DECLA_STATIC_TEMPLATE_BASE = 35;

/** Fila Signed = staticStart + offset (67 cuando staticStart = 35). */
export const PK_DECLA_FOOTER_OFFSET_FROM_STATIC = 32;

const ROW_TABLE_DATA_START = 22;

/**
 * Filas Excel: mercadería / legal / pie según N contenedores (tabla crece, lo demás baja).
 */
export function pkDeclaExcelLayoutRows(containerCount) {
  const n = Math.max(1, containerCount);
  const lastTableRow = ROW_TABLE_DATA_START + n - 1;
  const merchRow = lastTableRow + 3;
  const staticStart = merchRow + 5;
  const footerSignedRow = staticStart + PK_DECLA_FOOTER_OFFSET_FROM_STATIC;
  return { lastTableRow, merchRow, staticStart, footerSignedRow, printLastRow: footerSignedRow + 1 };
}

/** ~3 filas Excel entre tabla y mercadería (lastTableRow + 3). */
export const PK_DECLA_GAP_AFTER_TABLE_MM = 9;

/** ~1 fila entre mercadería y bloque legal. */
export const PK_DECLA_GAP_AFTER_MERCH_MM = 4.2;
